import { onErrorCaptured } from "vue";
import i18next from "../i18next";

import type { FlashMessageData, ApiErrorMessage } from "@/types/flashMessages";
import { addErrorBase } from "@/stores/messages";

function initCaptureErrorCaptured(
  messageKey: string,
  group: string
) {
  onErrorCaptured((err, instance, info) => {
    // if (err.name !== "CanceledError") {
    //   addErrorBottom({
    //     id: err.message,
    //     message: t(messageKey, {
    //       msg: err.message,
    //       info,
    //     }),
    //   });
    // }
    console.groupCollapsed(`[${group}] [${info}]`);
    console.error(err);
    console.log(instance);
    console.log(info);
    console.groupEnd();
    return false;
  });
}

export function useAppErrorCapture() {
  initCaptureErrorCaptured("message.app_error", "AppError");
}

export function useViewErrorCapture() {
  initCaptureErrorCaptured("message.view_error", "ViewError");
}

export function useComponentErrorCapture() {
  initCaptureErrorCaptured("message.component_error", "ComponentError");
}

/**
* @param translationKey - Translation key without ending: '.error_status' or '.error_code'. For example: 'macro.settings.update' => add to translations: 'macro.settings.update.error_status'
* */
export function getErrorMessage(m: FlashMessageData | string, translationKey: string | null = null) : { message: string } {
  let message = i18next.t('error.unknown_error');

  if (!m) {
    return { message: message };
  }

  if (typeof m === 'string') {
    return { message: m };
  }

  if ("code" in m && m.code === "ECONNABORTED" && typeof m.message === 'string' && m.message.includes('timeout')) {
    return { message: i18next.t('error.HAS_TIMEOUT') };
  }

  if ("code" in m && i18next.exists('api_errors.generic_error')) {
    message = `${i18next.t('api_errors.generic_error')}${m.code}`;
  }

  if ("response" in m) {
    const { response } = m as ApiErrorMessage;
    const responseCode = response?.data?.code;
    const responseStatus = response?.status;

    if (translationKey != null && response) {
      if (responseCode && i18next.exists(`${translationKey}.error_code.${responseCode}`)) {
        message = i18next.t(`${translationKey}.error_code.${responseCode}`);
      } else if (responseStatus && i18next.exists(`${translationKey}.error_status.${responseStatus}`)) {
        message = i18next.t(`${translationKey}.error_status.${responseStatus}`);
      } else if (responseStatus && i18next.exists(`api_errors.error_status.${responseStatus}`)) {
        message = i18next.t(`api_errors.error_status.${responseStatus}`);
      }
    } else if (response && responseStatus && i18next.exists(`api_errors.error_status.${responseStatus}`)) {
      message = i18next.t(`api_errors.error_status.${responseStatus}`);
    }
  }

  return { message: message || '' };
}

export function errorOnChange(e: any) {
  addErrorBase(e);
}
